/**
 * Extrai o assunto legível de `changes.diff_summary` (campo `subject` na API).
 * Remove metadados como "| Origem: MMA Power BI …" e o prefixo "Assunto:".
 */
export function formatChangeAssuntoDisplay(raw: string | null | undefined): string | null {
  if (!raw?.trim()) return null;

  let text = raw.trim();

  const origemIdx = text.search(/\s*\|\s*Origem\s*:/i);
  if (origemIdx >= 0) {
    text = text.slice(0, origemIdx).trim();
  }

  const assuntoMatch = text.match(/Assunto\s*:\s*([^|]+)/i);
  if (assuntoMatch) {
    const value = assuntoMatch[1].trim();
    return value || null;
  }

  return null;
}

/** Resolve assunto para exibição: diff_summary (subject) ou area_tematica canônica. */
export function resolveChangeAssuntoDisplay(
  subject?: string | null,
  areaTematica?: string | null,
): string | null {
  const fromSubject = formatChangeAssuntoDisplay(subject);
  if (fromSubject) return fromSubject;
  const fromArea = areaTematica?.trim();
  return fromArea || null;
}
